<template>
  <div id="JournalDetails">
    <div class="JournalDetails">
      <div class="details_box">
        <div class="left_Title">
          <p>
            <i class="iconfont iconjieguo"></i>
            <span class="aqt_lang_mn titlefont">{{ $t('m.details') |U2M }}</span>
          </p>
          <p></p>
        </div>
        <!--      详情-->
        <div class="book_brief">
          <!--        <div class="pdfButton"><img v-if="infosData&&infosData.annex>0" @click="showSelectPdf"  src="@/assets/images/pdf.png"></div>-->
          <div class="left_brief">
            <div class="img_banner">

              <Carousel>
                <CarouselItem v-for="(item,index) in imgList" :key="index">
                  <!--                <img class="img" v-lazy="item.images">-->
                  <el-image
                      :src="item.images"
                      :preview-src-list="srcList">
                  </el-image>
                </CarouselItem>
              </Carousel>

              <div v-if="infosData.annex>0" class="label">PDF</div>
            </div>
            <div class="books_info" v-if="infosData">
              <div class="title">
                <p class="aqt_lang_mn titlefont">
                  {{
                    infosData.titlelang ? infosData.titlelang.mn ? infosData.titlelang.mn : infosData.titlelang.zh : '' | U2M
                  }}</p>
              </div>
              <div class="aqt_zhengzhuang">
                <p class="aqt_lang_mn contentfont">ISSN: {{
                    infosData.issn ? infosData.issn : '' | U2M
                  }}</p>
              </div>
              <div class="aqt_zhengzhuang">
                <p class="aqt_lang_mn contentfont">CN : {{ infosData.cn ? infosData.cn : '' | U2M }}</p>
              </div>
              <div class="aqt_zhengzhuang">
                <p class="aqt_lang_mn contentfont">{{ $t('m.qishu')|U2M }}
                  : {{ infosData.number }}</p>
              </div>
              <div class="aqt_zhengzhuang">
                <p class="aqt_lang_mn contentfont">{{ $t('m.Competentunit')|U2M }}
                  : {{
                    infosData.supervisor_unitlang ? infosData.supervisor_unitlang.mn ? infosData.supervisor_unitlang.mn : infosData.supervisor_unitlang.zh : '' | U2M
                  }}</p>
              </div>
              <div class="aqt_zhengzhuang">
                <p class="aqt_lang_mn contentfont">{{ $t('m.Sponsor')|U2M }}
                  : {{
                    infosData.host_unitlang ? infosData.host_unitlang.mn ? infosData.host_unitlang.mn : infosData.host_unitlang.zh : '' | U2M
                  }}</p>
              </div>
              <div class="aqt_zhengzhuang">
                <p class="aqt_lang_mn contentfont">{{ $t('m.edit')|U2M }} :
                  {{
                    infosData.edit_publishinglang ? infosData.edit_publishinglang.mn ? infosData.edit_publishinglang.mn : infosData.edit_publishinglang.zh : '' | U2M
                  }}</p>
              </div>
              <div class="aqt_zhengzhuang">
                <p class="aqt_lang_mn contentfont">{{ $t('m.publish')|U2M }} :
                  {{
                    infosData.publishinglang ? infosData.publishinglang.mn ? infosData.publishinglang.mn : infosData.publishinglang.zh : '' | U2M
                  }}</p>
              </div>

              <div class="aqt_zhengzhuang">
                <p class="aqt_lang_mn contentfont">{{ $t('m.chief_editor')|U2M }} :
                  {{
                    infosData.editorlang ? infosData.editorlang.mn ? infosData.editorlang.mn : infosData.editorlang.zh : '' | U2M
                  }}</p>
              </div>
              <div class="aqt_zhengzhuang">
                <p class="aqt_lang_mn contentfont">{{ $t('m.deputy_chief_editor')|U2M }} :
                  {{
                    infosData.deputy_editorlang ? infosData.deputy_editorlang.mn ? infosData.deputy_editorlang.mn : infosData.deputy_editorlang.zh : '' | U2M
                  }}</p>
              </div>


              <div class="aqt_zhengzhuang">
                <p class="aqt_lang_mn contentfont">{{ $t('m.Price')|U2M }}: {{
                    infosData.price ? infosData.price : ''
                  }}</p>
              </div>
              <div class="aqt_zhengzhuang">
                <p class="aqt_lang_mn contentfont">{{ $t('m.downNum')|U2M }} : {{
                    infosData.dowload ? infosData.dowload : ''
                  }}</p>
              </div>

              <!--阅读量-->
              <div class="aqt_zhengzhuang">
                <p class="aqt_lang_mn contentfont">
                  <span>{{ $t('m.readingNum')|U2M }} : </span>
                  {{ infosData ? infosData.pageviews : '' }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <!--      pdf-->
        <div class="book_pdflist" v-if="pdfList.length">
          <div class="_Title">
            <p>
              <i></i>
              <span class="aqt_lang_mn titlefont">{{ $t('m.Ebook') |U2M }}</span>
            </p>
          </div>
          <div class="_pdflist">
            <div class="list__pdflist" :style="{color:pdfShow==item.id?'var(--themeColor)':'#888888'}"
                 @click="annexChange(item)"
                 v-for="(item,index) in pdfList" :key="index">
              <p class="aqt_lang_mn contentfont">
                {{ item.name ? item.name : '' | U2M }}
              </p>
              <p class="aqt_lang_mn contentfont">{{ change(item.size) }}</p>
            </div>
          </div>
        </div>

        <div v-if="url" style="margin-right: 10px">
          <text-content v-if="url" :pdfUrl="url" :type="2" :isContent="infosData.iscontent"
                        :infoId="infoId" :ShowOpertion="'opertion'"></text-content>
        </div>
        <!--    加载动画-->
        <AqtSpin v-if="isSpin"></AqtSpin>
      </div>
      <div class="cata_box" :style="{width:isSpinml?'100%':(!catalogueListMn.length&&!catalogueListZh.length&&!catalogueListEn.length?'0':'100%')}">
        <!--      目录-->
        <div class="book_catalogue" v-if="catalogueListMn.length||catalogueListZh.length||catalogueListEn.length">
          <div class="_Title" style="width: 60px">
            <p>
              <i></i>
              <span class="aqt_lang_mn titlefont">{{ $t('m.mulan') |U2M }}</span>
            </p>
            <div v-if="catalogueListMn.length&&(catalogueListZh.length||catalogueListEn.length)"
                 class="catalogue_button aqt_lang_mn titlefont" :class="showCatalogue=='mn'?'button_active':''"
                 @click="getLangCata('mn')">{{ $t('m.Mongolian') }}
            </div>
            <div v-if="catalogueListZh.length&&(catalogueListMn.length||catalogueListEn.length)"
                 class="catalogue_button aqt_su" :class="showCatalogue=='zh'?'button_active':''"
                 @click="getLangCata('zh')">中文
            </div>
            <div v-if="catalogueListEn.length&&(catalogueListMn.length||catalogueListZh.length)"
                 class="catalogue_button aqt_lang_mn" :class="showCatalogue=='en'?'button_active':''"
                 @click="getLangCata('en')">English
            </div>
          </div>
          <div v-if="catalogueListMn.length&&showCatalogue=='mn'" class="_catalogue">
            <div @click="CheckPdf(item)"
                 :style="{background:directoryId==item.directory_id?'rgba(0, 0, 0, 0.1)':'',color:directoryId==item.directory_id?'var(--themeColor)':'',cursor:item.original?'pointer':''}"
                 class="list_catalogue" v-for="(item,index) in catalogueListMn" :key="index">
              <p class="aqt_lang_mn contentfont" v-html="U2M(item.titlelang.mn)"></p>
              <p v-if="item.page" class="aqt_lang_mn contentfont">({{ item.page ? item.page : '' }})</p>
            </div>
          </div>

          <div v-if="catalogueListZh.length&&showCatalogue=='zh'" class="_catalogue_zh_en">
            <div @click="CheckPdf(item)"
                 :style="{background:directoryId==item.directory_id?'rgba(0, 0, 0, 0.1)':'',color:directoryId==item.directory_id?'var(--themeColor)':'',cursor:item.original?'pointer':''}"
                 class="list_catalogue_zh_en" v-for="(item,index) in catalogueListZh" :key="index">
              <p v-html="item.titlelang.zh"></p>
              <p v-if="item.page">({{ item.page ? item.page : '' }})</p>
            </div>
          </div>

          <div v-if="catalogueListEn.length&&showCatalogue=='en'" class="_catalogue_zh_en">
            <div @click="CheckPdf(item)"
                 :style="{background:directoryId==item.directory_id?'rgba(0, 0, 0, 0.1)':'',color:directoryId==item.directory_id?'var(--themeColor)':'',cursor:item.original?'pointer':''}"
                 class="list_catalogue_zh_en" v-for="(item,index) in catalogueListEn" :key="index">
              <p v-html="item.titlelang.en"></p>
              <p v-if="item.page">({{ item.page ? item.page : '' }})</p>
            </div>
          </div>
        </div>
        <!--    加载动画-->
        <AqtSpin v-if="isSpinml"></AqtSpin>
      </div>


      <file_preview style="display:none" :file_name="url" ref="file_preview"></file_preview>
    </div>
    <!--    加载动画-->
    <AqtSpin v-if="isSpinpdf"></AqtSpin>
    <!--    <goback style="top:30px!important;right: 90px!important;"></goback>-->
    <aqt-sidebar-mn v-model="showsidebar" :title="titleStr" slot="others" class="aqt_su" :width="100">
      <component class="aqt_no_su" :is="which_to_show" :infoId="dirifoIds" :periodicalId="periodicalId"></component>
    </aqt-sidebar-mn>
  </div>
</template>
<script>
import Vue from "vue";

export default {
  props: {
    infoId: {
      type: [String, Number],
      default: ''
    },
    directoryId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      isSpin: false,
      isSpinpdf:false,
      isSpinml:false,
      imgList: [],
      srcList: [],
      pdfList: [],
      catalogueListMn: [],
      catalogueListZh: [],
      catalogueListEn: [],
      infosData: '',
      url: '',//pdf路径
      pdfShow: '',

      showsidebar: false,
      titleStr: '',
      which_to_show: '',
      dirifoIds: '',
      periodicalId: '',

      showCatalogue: 'mn'
    }
  },
  components: {
    //文字内容查看
    TextContent: re => require(['@/components/MN/TextContent'], re),
    JournalMue: (re) => require(['./JournalMue.vue'], re),//期刊详情
  },
  methods: {
    //  获取详情
    getbookDetails() {
      const _this = this;
      _this.isSpin = true
      let condition = {
        member_id: _this.member_id,
        library_id: _this.library_id,
        periodical_id: _this.infoId,

        terminal: _this.$terminal,
        wificode: _this.$store.getters.wificode,// Wi-Fi码
        network: _this.$store.getters.network,// 网络
        devicecode: _this.$store.getters.uuid,//设备码,
        latlon: _this.$store.getters.latlon,// 经纬度
      }
      _this.$httpsencrypt.post(`api/web/v3/periodical/webfind`, condition)
          .then((val) => {
            if (val.code == 200 && val.data) {
              _this.infosData = val.data
              if (val.data.annexlist && val.data.annexlist.length) {
                _this.pdfList = val.data.annexlist.map(item => {
                  return {
                    type: '',
                    url: '',
                    name: item.name,
                    size: item.size,
                    videopic: '',
                    voratime: '',
                    lx: '',
                    id: item.resources_id,
                  }
                })
              } else {
                _this.pdfList = []
              }
              //轮播图
              _this.getIntors()
              //pdf
              // if (val.data.annex > 0) {
              //   _this.showSelectPdf()
              // }
              //目录
              // _this.getCatalogue()
              _this.isSpin = false
            } else {
              _this.isSpin = false
            }
          }).catch(e => {
        _this.isSpin = false
      })
    },
    //获取pdf
    showSelectPdf(value) {
      let that = this
      if (value.url) {
        this.url = value.url
        this.saveUserBehavior(36, '期刊详情pdf资源查看', value.id)
      } else {
        that.isSpinpdf = true
        let condition = {
          model: 'QiKan',
          filetype: 'File',
          level: 'AQT_2023_1',
          id: that.infoId,
          type1: 2,
          name: '期刊详情pdf按钮',
        }

        that.$getResources(condition).then(val => {
          if (val.code == 200) {

            that.pdfList.forEach(item2 => {
              let findInfor = val.data.find((item1) => {
                return item1.resources_id == item2.id
              })
              if (findInfor) {
                item2.type = findInfor.type
                item2.url = findInfor.url ? that.$webcrypto.get(findInfor.url) : ''
                item2.videopic = findInfor.videopic
                item2.voratime = findInfor.voratime
                item2.lx = findInfor.lx
              }
              if (item2.id == value.id && item2.url) {
                this.url = item2.url
                this.saveUserBehavior(36, '期刊详情pdf资源查看', value.id)

              }
            });

          } else {
            that.$Message.warning({
              content: val.message
            })
          }
          that.isSpinpdf = false
        }).catch((err) => {
          that.isSpinpdf = false
        });
      }

    },
    //  获取目录
    getCatalogue() {
      const _this = this;
      _this.isSpinml = true
      _this.catalogueListMn = [];
      _this.catalogueListZh = [];
      _this.catalogueListEn = [];
      let cond = {
        book_id: _this.infoId,
        type: 2,//1.书目录 2.期刊目录 3报刊 4普通论文
        member_id: _this.member_id,
        library_id: _this.library_id,
        terminal: _this.$terminal,
        wificode: _this.$store.getters.wificode,// Wi-Fi码
        network: _this.$store.getters.network,// 网络
        devicecode: _this.$store.getters.uuid,//设备码,
        latlon: _this.$store.getters.latlon,// 经纬度
      }
      _this.$httpsencrypt.post(`api/web/v3/directory/newindex`, cond)
          .then((val) => {
            _this.catalogueListMn = [];
            _this.catalogueListZh = [];
            _this.catalogueListEn = [];
            _this.handelSlugData(val.data, 0);
            if (_this.catalogueListMn.length) {
              _this.showCatalogue = 'mn'
            } else if (_this.catalogueListZh.length) {
              _this.showCatalogue = 'zh'
            } else if (_this.catalogueListEn.length) {
              _this.showCatalogue = 'en'
            }
            _this.isSpinml = false
          }).catch((err) => {
        _this.isSpinml = false
        _this.catalogueListMn = [];
        _this.catalogueListZh = [];
        _this.catalogueListEn = [];
      });
    },
    /************************************************************
     *
     * 处理数据格式
     *
     ************************************************************/
    handelSlugData(data, label) {
      const title = label
      data.map((el, ind) => {
        el.titlelang.mn = (el.titlelang.mn ? `<p class="aqt_lang_mn contentfont" style="height:calc(100% - ${title}px);margin-top:${title}px;"> ${el.titlelang.mn}</p>` : ``)
        el.titlelang.zh = (el.titlelang.zh ? `<p style="width:calc(100% - ${title}px);margin-left:${title}px;"> ${el.titlelang.zh}</p>` : ``)
        el.titlelang.en = (el.titlelang.en ? `<p style="width:calc(100% - ${title}px);margin-left:${title}px;"> ${el.titlelang.en}</p>` : ``)
        if (el.titlelang.mn) {
          this.catalogueListMn.push(el)
        }
        if (el.titlelang.zh) {
          this.catalogueListZh.push(el)
        }
        if (el.titlelang.en) {
          this.catalogueListEn.push(el)
        }
        let label = title + 20
        if (el.child.length !== 0) this.handelSlugData(el.child, label)

      })
    },
    getLangCata(lang) {
      this.showCatalogue = lang
    },
    //获取多图
    getIntors() {
      const _this = this
      _this.imgList = []
      _this.srcList = []
      let condition = {
        model: 'QiKan',
        filetype: 'Image',
        level: 'AQT_2023_2',
        id: _this.infoId,
        type1: 2,
        name: '期刊详情多图',
      }
      _this.$getResources(condition).then((val) => {
        if (_this.infosData.imgm) {
          _this.srcList.push(_this.$webcrypto.get(_this.infosData.imgm))
          let a = {
            images: _this.$webcrypto.get(_this.infosData.imgm)
          }
          _this.imgList.push(a)
        }

        if (val.code == 200 && val.data.length) {
          val.data.forEach(item => {
            let b = {
              images: _this.$webcrypto.get(item)
            }
            _this.imgList.push(b)
            _this.srcList.push(_this.$webcrypto.get(item))
          });
        }
      }).catch((err) => {
      });

    },
    change(limit) {
      var size = "";
      if (limit < 0.1 * 1024) {                            //小于0.1KB，则转化成B
        size = limit.toFixed(2) + "B"
      } else if (limit < 0.1 * 1024 * 1024) {            //小于0.1MB，则转化成KB
        size = (limit / 1024).toFixed(2) + "KB"
      } else if (limit < 0.1 * 1024 * 1024 * 1024) {        //小于0.1GB，则转化成MB
        size = (limit / (1024 * 1024)).toFixed(2) + "MB"
      } else {                                            //其他转化成GB
        size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB"
      }

      var sizeStr = size + "";                        //转成字符串
      var index = sizeStr.indexOf(".");                    //获取小数点处的索引
      var dou = sizeStr.substr(index + 1, 2)            //获取小数点后两位的值
      if (dou == "00") {                                //判断后两位是否为00，如果是则删除00
        return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2)
      }
      return size;
    },
    //查看目录的pdf
    CheckPdf(data) {
      let that = this
      that.which_to_show = 'JournalMue'
      that.showsidebar = true
      that.titleStr = that.$t('m.details')
      that.dirifoIds = data.directory_id
      that.periodicalId = that.infoId
      that.$loginPd()
    },
    annexChange(data) {
      this.pdfShow = data.id
      this.showSelectPdf(data)
    },
    //查看pdf
    saveUserBehavior(type, mark, id) {
      let that = this
      let info = {
        book_id: id,
        magazine_id: null,
        type: type,
        path: this.$route.path,
        mark: mark,
      }
      that.$store.dispatch('saveUserBehavior', info).then(() => {
      })

    },
  },
  created() {
    this.getbookDetails()
    this.getCatalogue()
    let info = {
      book_id: this.infoId,
      type: 2,
      path: this.$route.path,
      mark: '期刊详情',
    }
    this.$store.dispatch('saveUserBehavior', info).then(() => {
    })
  },
  computed: {

    // 馆藏id
    library_id() {
      let vv = localStorage.getItem("theme_color") ? JSON.parse(this.$crypto.get(localStorage.getItem("theme_color"))).library_id : "";
      return vv
    },
    // 用户id
    member_id() {
      let mm = localStorage.getItem("userInfoMemberId") ? JSON.parse(this.$crypto.get(localStorage.getItem("userInfoMemberId"))).member_id : ''
      return mm
    },
  },
}
</script>

<style lang="less" scoped>
#JournalDetails {
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;

  .JournalDetails {
    width: 100%;
    height: 100%;
    display: flex;
    overflow-x: auto;

    .details_box {
      position: relative;
      display: flex;
    }
    .cata_box{
      position: relative;
      display: flex;
    }

    .left_Title {
      min-width: 54px;
      height: 100%;
      background: #ffffff;
      margin-right: 2px;
      padding-top: 27px;
      display: flex;
      justify-content: flex-end;

      p:nth-child(1) {
        width: 24px;
        color: var(--themeColor);
        font-size: 20px;
        line-height: 24px;

        i {
          font-size: 24px;
        }
      }

      p:nth-child(2) {
        width: 4px;
        height: 162px;
        background: var(--themeColor);
        margin-left: 10px;
      }
    }

    ._Title {
      width: 54px;
      height: 100%;
      background: #ffffff;
      margin-right: 2px;
      padding-top: 35px;
      color: #888888;
      display: flex;
      flex-direction: column;
      align-items: center;


      p:nth-child(1) {
        width: 24px;
        font-size: 20px;
        line-height: 24px;

        i {
          display: block;
          width: 27px;
          height: 13px;
          background: var(--themeColor);
          margin-bottom: 14px;
        }
      }

      .catalogue_button {
        width: 30px;
        cursor: pointer;
        border: 1px solid var(--themeColor);
        margin-top: 10px;
        border-radius: 5px;
        color: var(--themeColor);
        //padding: 6px 2px;
        padding: 6px 0;
        line-height: 30px;
        font-size: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .button_active {
        background: var(--themeColor);
        color: #ffffff;
      }

      .catalogue_button:hover {
        background: #F5F5F5;
        color: var(--themeColor);
      }
    }

    .book_brief {
      //min-width: 200px;
      height: 100%;
      background: #ffffff;
      margin-right: 10px;
      padding: 27px 10px;
      display: flex;
      position: relative;

      .pdfButton {
        width: 50px;
        height: 50px;
        position: absolute;
        top: 0;
        right: 0;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 30px;
          height: auto;
          cursor: pointer;
        }
      }

      .left_brief {
        min-width: 180px;
        height: 100%;

        .img_banner {
          width: 180px;
          height: 270px;
          margin: 0 auto;
          position: relative;
          overflow: hidden;

          img {
            width: 180px;
            height: 100%;
            border-radius: 5px;
          }

          .label {
            line-height: 24px;
            height: 20px;
            height: 20px;
            background: red;
            color: #fff;
            font-size: 12px;
            position: absolute;
            right: 0;
            top: 0;
            z-index: 2;
            padding: 0 15px;
            -webkit-transform-origin: left bottom;
            -moz-transform-origin: left bottom;
            transform-origin: left bottom;
            -webkit-transform: translate(29.29%, -100%) rotate(45deg);
            -moz-transform: translate(29.29%, -100%) rotate(45deg);
            transform: translate(29.29%, -100%) rotate(45deg);
            text-indent: 0;
          }
        }

        .books_info {
          display: flex;
          min-width: 180px;
          padding-top: 10px;
          height: calc(100% - 270px);

          .title {
            height: 100%;
            color: #888888;
            font-size: 1.8rem;
            margin: 0 0.3rem;

            p {
              word-wrap: break-word;
              word-break: normal;
              height: 100%;
            }
          }

          .aqt_zhengzhuang {
            height: 100%;
            color: #888888;
            font-size: 1.2rem;
            margin: 0 .3rem;

            p {
              font-size: 1.6rem;
              word-wrap: break-word;
              word-break: normal;
              height: 100%;
              color: #888888;
            }
          }
        }
      }

    }

    .book_pdflist {
      height: 100%;
      margin-right: 10px;
      display: flex;

      ._pdflist {
        height: 100%;
        padding: 35px 17px;
        display: flex;
        background: #ffffff;

        .list__pdflist {
          height: 100%;
          color: #888888;
          font-size: 1.8rem;
          margin: 0 0.3rem;
          //background: #F2F7FF;
          background: #eeeeee;
          padding: 10px;
          cursor: pointer;

          p:nth-child(1) {
            height: 85%;
          }

          p:nth-child(2) {
            height: 15%;
            text-align: center;
          }
        }

        .list__pdflist:hover {
          color: var(--themeColor);
        }
      }
    }

    .book_catalogue {
      width: 100%;
      height: 100%;
      margin-right: 10px;
      display: flex;

      ._catalogue {
        height: 100%;
        padding: 30px 10px;
        display: flex;
        background: #ffffff;

        .list_catalogue {
          height: 100%;
          color: #888888;
          font-size: 1.8rem;
          margin: 0 0.3rem;
          padding: 5px 0;
          cursor: pointer;

          p:nth-child(1) {
            height: 92%;
          }

          p:nth-child(2) {
            height: 8%;
            text-align: center;
            margin: 0 auto;
          }
        }

        .list_catalogue:hover {
          background: rgba(0, 0, 0, 0.1);
        }
      }

      ._catalogue_zh_en {
        width: 45vw;
        height: 100%;
        padding: 10px 30px;
        background: #ffffff;
        overflow-y: auto;

        .list_catalogue_zh_en {
          width: 100%;
          color: #888888;
          font-size: 1.8rem;
          margin: 0.3rem 0;
          padding: 0 5px;
          cursor: pointer;
          display: flex;

          p:nth-child(1) {
            width: 92%;
          }

          p:nth-child(2) {
            width: 8%;
            text-align: center;
            margin: 0 auto;
          }
        }

        .list_catalogue_zh_en:hover {
          background: rgba(0, 0, 0, 0.1);
        }
      }

      ._catalogue_zh_en::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 12px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 12px;
      }

      ._catalogue_zh_en::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 5px;
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: rgba(0, 0, 0, 0.2);
      }

      ._catalogue_zh_en::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 0;
        background: rgba(0, 0, 0, 0.1);
      }

    }
  }

  .JournalDetails::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 12px;
  }

  .JournalDetails::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }

  .JournalDetails::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }

}
</style>

<style lang="less">
#JournalDetails {
  .ivu-carousel {
    height: 100% !important;

    .ivu-carousel-list {
      height: 100% !important;

      .ivu-carousel-track {
        height: 100% !important;

        .ivu-carousel-item {
          height: 100% !important;
        }
      }
    }
  }

  .ivu-carousel-dots li button {
    opacity: unset !important;
    width: 5px !important;
    height: 5px !important;
    border-radius: 50%;
  }

  .ivu-carousel-dots li.ivu-carousel-active > button {
    opacity: unset !important;
    background: var(--themeColor);
  }

  .ivu-carousel-dots-inside {
    bottom: 15px !important;
  }
}
</style>
